import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

import Home from "./pages/Home";
import ServicesPage from "./pages/ServicesPage";
import GameDevelopment from "./pages/GameDevelopment";
import WebDevelopment from "./pages/WebDevelopment";
import WhatsAppButton from "./components/WhatsAppButton";
import MobileAppDevelopment from "./pages/MobileAppDevelopment";
import SoftwareDevelopment from "./pages/SoftwareDevelopment";
import ScrollToTop from "./components/ScrollToTop";
import EndToEndGameDevelopment from "./pages/gameServices/EndToEndGameDevelopment";
import Blog  from "./pages/Blog";
import Admin from "./pages/Admin"
import BlogArticle from "./pages/BlogArticle";

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />

        <Route path="/services" element={<ServicesPage />} />

        <Route
          path="/services/game-development"
          element={<GameDevelopment />}
        />

        <Route
          path="/services/mobile-app-development"
          element={<MobileAppDevelopment />}
        />

        <Route
          path="/services/software-development"
          element={<SoftwareDevelopment />}
        />

        <Route
          path="/services/web-development"
          element={<WebDevelopment />}
        />

        <Route
          path="/services/game-development/end-to-end"
          element={<EndToEndGameDevelopment />}
        />

        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogArticle />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <WhatsAppButton />
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;